import type { CustomFieldValues } from "@forgepoint/shared";
import { ReadOnlyValue } from "@/components/customFields/ReadOnlyValue";

/** Displays imported inventory attributes using the shared read-only field renderer. */
export function InventoryMetadata({ values }: { values: CustomFieldValues }) {
  const fields = Object.entries(values);
  if (!fields.length) {
    return "—";
  }
  return (
    <div className="space-y-1 break-words">
      {fields.map(([name, value]) => (
        <div key={name} className="flex flex-wrap items-center gap-1">
          <span className="text-muted-foreground">{name}: </span>
          <ReadOnlyValue
            value={value}
            type={getFieldType(value)}
            inline={false}
          />
        </div>
      ))}
    </div>
  );
}

function getFieldType(
  value: CustomFieldValues[string],
): "string" | "number" | "array" {
  if (Array.isArray(value)) {
    return "array";
  }
  if (typeof value === "number") {
    return "number";
  }
  return "string";
}
